module.exports = __webpack_public_path__ + "assets/f5c61aa299e5666dd36bd556876194c2.mp3";